var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLostSubscribers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    rx: 17,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 17.667 28.3813)",
    fill: "#FDCB6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5586 30.2041C44.5159 30.3073 44.4526 30.404 44.3687 30.4879C44.2848 30.5718 44.1881 30.635 44.0849 30.6777C43.9911 30.7166 43.8919 30.7384 43.792 30.7431C43.778 30.7438 43.764 30.7441 43.75 30.7441C43.7497 30.7441 43.7503 30.7441 43.75 30.7441H35C34.5168 30.7441 34.125 30.3524 34.125 29.8691C34.125 29.3859 34.5168 28.9941 35 28.9941H41.6376L30.3687 17.7253C30.027 17.3836 29.473 17.3836 29.1313 17.7253L24.6062 22.2504C23.581 23.2755 21.919 23.2755 20.8938 22.2504L11.6313 12.9879C11.2896 12.6462 11.2896 12.0921 11.6313 11.7504C11.973 11.4087 12.527 11.4087 12.8687 11.7504L22.1313 21.013C22.473 21.3547 23.027 21.3547 23.3687 21.013L27.8938 16.4879C28.919 15.4627 30.581 15.4627 31.6062 16.4879L42.875 27.7567V21.1191C42.875 20.6359 43.2668 20.2441 43.75 20.2441C44.2332 20.2441 44.625 20.6359 44.625 21.1191V29.8691C44.625 29.9878 44.6014 30.1009 44.5586 30.2041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostSubscribers);
export default __webpack_public_path__ + "static/media/lost-subscribers.e165b0216ccc65cf6c5df0c68d30ddaa.svg";
export { ForwardRef as ReactComponent };